module.exports = __webpack_public_path__ + "static/media/agreement.04313bf6.jpg";